// extracted by mini-css-extract-plugin
export default {"root":"Home_root__3D9cb","categorySort":"Home_categorySort__x8f1j"};